import React, { useEffect, useState } from 'react';

import { Button, Form, Modal } from 'react-bootstrap-5';
import { isEmpty } from 'lodash';
import { createCallList, getProspectAccountMembers } from '../../helpers/prospect_api';
import type { CallList } from 'bundles/connect/types';
import ManageCallListUsers, { type CallListUser } from '../call_list/manage_call_list_users';

type Props = {
  defaultName?: string;
  show?: boolean;
  onClose: () => void;
  onCreate: (callList: CallList) => void;
}

export default function CreateListModal({ defaultName, show, onClose, onCreate }: Props) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [saving, setSaving] = useState(false);
  const [users, setUsers] = useState<CallListUser[]>([]);
  const [checkedUsers, setCheckedUsers] = useState<number[]>([]);

  const handleSave = () => {
    setSaving(true);

    createCallList(name, description, checkedUsers)
      .then((newCallList: CallList) => {
        onCreate(newCallList);
      })
      .finally(() => setSaving(false));
  };

  useEffect(() => {
    if (show) {
      setName(defaultName || '');
      setDescription('');

      getProspectAccountMembers().then((res) => {
        setUsers(res);
        setCheckedUsers(res.filter(user => user.currentUser).map(user => user.id));
      });
    }
  }, [show]);

  return (
    <Modal
      centered
      show={show}
      onHide={onClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>New List</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="formCallListName">
            <Form.Label>Name</Form.Label>
            <Form.Control name="name" type="text" value={name} onChange={e => setName(e.target.value)} />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formCallListDescription">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              name="description"
              rows={3}
              value={description}
              onChange={e => setDescription(e.target.value)}
            />
          </Form.Group>

          {users.length > 1 && (
            <ManageCallListUsers
              checkedUsers={checkedUsers}
              setCheckedUsers={setCheckedUsers}
              users={users}
            />
          )}
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="link" onClick={onClose}>Cancel</Button>
        <Button disabled={saving || isEmpty(name)} variant="primary" onClick={handleSave}>
          {saving ? 'Saving...' : 'Save List'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
